<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import smooth from "../lib/smooth";
import SplitType from "split-type";
import {getElementSizing} from "@straylightagency/utils/dom";

const el = ref();

let splitType;
let length = 0;
let position = 0;

const start = 1;
const end = 0.1;
const step = 0.085;
const stepEl = 4;
const multiply = 0.125;

const scribeOnScroll = deltaY => {
    position = deltaY;

    const wh = window.innerHeight;
    const margin = wh / 2;

    if ( position > 0 ) {
        const pos_y = position * multiply;

        const sizing = getElementSizing( el.value );
        const bottom = sizing.bottom + pos_y;

        if ( pos_y > bottom ) {
            return;
        }

        const current = pos_y + wh;
        const top = (current - sizing.top) - margin;

        const percentage = Math.max( 0, Math.min( 100, (top * 100) / bottom ) );
        const percentage2 = Math.min( 100, (top * 100) / bottom );

        const nbr = Math.floor( (percentage * length) / 100 );
        const nbr2 = Math.floor( (percentage2 * length) / 100 );

        let i = start;
        let l = 0;

        while ( i >= end ) {
            if ( nbr2 < 0 ) {
                l++;
                break;
            }

            if ( stepEl * l === 0 ) {
                splitType.chars.slice( 0, nbr ).forEach( el => {
                    el.style.opacity = i.toString();
                } );
            }

            let j = Math.round( ( i - step ) * 100 ) / 100;

            if ( j < end ) {
                splitType.chars.slice( nbr + ( l * stepEl ) ).forEach( el => el.style.opacity = end.toString() );
            } else {
                splitType.chars.slice( nbr + ( stepEl * ( l - 1 ) ), nbr + ( stepEl * l )).forEach( el => el.style.opacity = i.toString() );
            }

            i = j;
            l++;
        }

        splitType.chars.slice( nbr + ( ( l - 1 ) * stepEl ) ).forEach( el => el.style.opacity = end.toString() );
    }
};

const event = () => scribeOnScroll( document.documentElement.scrollTop || document.body.scrollTop );

onMounted( () => {
    splitType = new SplitType( el.value, {
        types: "lines, words, chars",
        tagName: "span"
    } );

    length = splitType.chars.length;

    scribeOnScroll( 0 );

    window.addEventListener('scroll', event );

    // smooth.add( scribeOnScroll );
} );

onUnmounted( () => {
    position = 0;

    window.removeEventListener('scroll', event );

    // smooth.remove( scribeOnScroll );
} );
</script>

<template>
    <div class="scribe-typing | relative px-2">
        <p ref="el" class="scribe | text-white text-xl md:text-4xl font-bold leading-loose md:leading-loose">
            <slot></slot>
        </p>
        <span class="corner-top-left corner-top-right"></span>
        <span class="corner-bottom-left corner-bottom-right"></span>
    </div>
</template>